import React, { useEffect, useMemo, useState } from "react";
import { isValidPhoneNumber } from "react-phone-number-input";
import Input from "react-phone-number-input/input";
import "react-phone-number-input/style.css";
import CopyButton from "../CopyButton/CopyButton";
import "./index.scss";

export const PhonePicker = ({ value, handleChange, className, disabled, style, placeholder, country, copy }) => {

	let orgData = JSON.parse(
		localStorage.getItem("organization") !== "undefined" ? localStorage.getItem("organization") : "{}"
	);

	const code = useMemo(() => {
		return orgData?.country?.code || "US";
	}, [orgData]);


	return (
		<div className={`phone-picker ${className} position-relative`}>
			<Input
				country={country || code}
				placeholder={placeholder ?? "Phone"}
				value={value}
				onChange={handleChange}
				maxLength="14"
				error={
					value ? (isValidPhoneNumber(value) === true ? undefined : "Invalid phone number") : "Phone number required"
				}
				disabled={disabled ? true : false}
				style={style ? style : {}}
			/>
			{(value && value?.trim() && copy) && (<CopyButton value={value} />)}
		</div>
	);
};
